import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "./LandingPageSection4.module.css";

gsap.registerPlugin(ScrollTrigger);

const LandingPageSection4 = () => {
  const chartRef = useRef(null);

  const points = [
    {
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 19h4V5H5v14zm6 0h4v-9h-4v9zm6 0h4V13h-4v6z" fill="currentColor" />
        </svg>
      ),
      title: "24/7 Live Coverage",
      desc: "Never miss a lead. Agents pick up every call, day or night."
    },
    {
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11 21h2v-8h5l-6-9-6 9h5v8z" fill="currentColor" />
        </svg>
      ),
      title: "Instant Qualification",
      desc: "Route hot prospects to your team the moment intent is detected."
    },
    {
      icon: (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L4 5v6c0 5.25 3.42 10.16 8 11.5 4.58-1.34 8-6.25 8-11.5V5l-8-3z" fill="currentColor" />
        </svg>
      ),
      title: "Enterprise-Grade Security",
      desc: "SOC 2 Type II, HIPAA-ready, end-to-end encrypted."
    }
  ];

  const chartBars = [45, 65, 50, 78, 70, 88, 98];

  useEffect(() => {
    const bars = chartRef.current.querySelectorAll(`.${styles.bar}`);
    
    // Smooth wavy entry stagger animation
    gsap.fromTo(
      bars,
      { scaleY: 0 },
      {
        scaleY: 1,
        duration: 1.5,
        transformOrigin: "bottom center",
        ease: "elastic.out(1, 0.5)",
        stagger: {
          each: 0.1,
          from: "start"
        },
        scrollTrigger: {
          trigger: chartRef.current,
          start: "top 85%"
        }
      }
    );
  }, []);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* Left Side: Text List */}
        <div className={styles.left}>
          <h2 className={styles.headline}>
            Transform business <br />
            calls into <span className={styles.gradientText}>growth opportunities.</span>
          </h2>
          <p className={styles.subheadline}>
            ToxBox AI turns every conversation into signal — actionable data, qualified leads, and closed loops.
          </p>

          <div className={styles.list}>
            {points.map((point, index) => (
              <div key={index} className={styles.listItem}>
                <div className={styles.iconCircle}>
                  <span className={styles.icon}>{point.icon}</span>
                </div>
                <div className={styles.listText}>
                  <h3 className={styles.listTitle}>{point.title}</h3>
                  <p className={styles.listDesc}>{point.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side: Gradient Chart Card */}
        <div className={styles.right}>
          <div className={styles.chartCard}>
            <div className={styles.chartHeader}>
              <span className={styles.chartTitle}>Growth this quarter</span>
              <span className={styles.badge}>+185%</span>
            </div>

            {/* Chart Area */}
            <div className={styles.chartArea} ref={chartRef}>
              {chartBars.map((height, idx) => (
                <div key={idx} className={styles.barWrapper}>
                  <div 
                    className={styles.bar} 
                    style={{ height: `${height}%` }}
                  ></div>
                </div>
              ))}
            </div>

            <div className={styles.metricsRow}>
              <div className={styles.metricItem}>
                <h4 className={styles.metricVal}>3.4x</h4>
                <p className={styles.metricLabel}>Conversion</p>
              </div>
              <div className={styles.metricItem}>
                <h4 className={styles.metricVal}>-67%</h4>
                <p className={styles.metricLabel}>Cost per lead</p>
              </div>
              <div className={styles.metricItem}>
                <h4 className={styles.metricVal}>0.6s</h4>
                <p className={styles.metricLabel}>Avg latency</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingPageSection4;